import { Column, isLinked, LinkableField } from '@synqo/frontend-component-library';
import { ApiInvoicePosition, EnumTaxationMode } from '@Model';
import { LinkOrder } from './LinkOrder';

export const invoicePositionColumns = (taxationMode: EnumTaxationMode): Column<ApiInvoicePosition>[] => [
    {
        name: 'number',
        label: 'Nr.',
        size: 75,
    },
    {
        name: 'service.display_string',
        label: 'Bezeichnung',
        size: 500,
    },
    {
        name: 'quantity',
        label: 'Menge',
        size: 200,
        type: 'decimal',
        decimalPlaces: (rowData) => rowData.service.decimal_places_amount,
    },
    taxationMode === EnumTaxationMode.PriceIsGross
        ? {
              name: 'total_gross_price',
              label: 'Brutto Preis in €',
              size: 200,
              type: 'currency',
              decimalPlaces: (rowData) => rowData.service.decimal_places_price,
          }
        : {
              name: 'total_net_price',
              label: 'Netto Preis in €',
              size: 200,
              type: 'currency',
              decimalPlaces: (rowData) => rowData.service.decimal_places_price,
          },
    {
        name: 'order',
        label: 'Auftrag',
        renderCell: ({ cellData }) => {
            const link = cellData as LinkableField;
            return isLinked(link) ? <LinkOrder order={link} /> : '';
        },
        size: 100,
        disableColumnFilter: true,
        disableColumnSort: true,
    },
];
